// AD-2758 (Maria, 23 October 2026): the component sidebar runs down to the bottom of the page, so as many components
// show as the window allows, and ends level with the page.
// - pageEnd: where the page can end without scrolling, 16px above the space below the white panel (the footer)
// - formEnd: 16px above the bottom of the form
// The sidebar ends at whichever is lower, never more than 8px from the bottom of the window, and is at least 200px.
export const paletteMaxHeight = ({innerHeight, top, belowPanel, formEnd}) => {
    const pageEnd = innerHeight - belowPanel - 16;
    const bottom = Math.min(innerHeight - 8, Math.max(pageEnd, formEnd - 16));
    return Math.max(bottom - Math.max(top, 0), 200);
};
